const AttachmentStack = ({
  count,
  showCount = true,
  width = 26,
  height = 33,
  radius = 3,
}: {
  count: number
  showCount?: boolean
  /** Total width of the stack in px */
  width?: number
  /** Total height of the stack in px */
  height?: number
  /** Corner radius of each card in px */
  radius?: number
}) => (
  <div className="relative shrink-0" style={{ width, height }}>
    <div
      className="absolute right-0 top-0 z-0 h-[88%] w-[85%] bg-[#82B1F1] shadow-md"
      style={{ borderRadius: radius }}
    />
    <div
      className="absolute bottom-0 left-0 z-10 h-[88%] w-[85%] border-r-2 border-t-2 border-surface bg-[#DAEAFF] shadow-md"
      style={{ borderRadius: radius }}
    />
    {showCount && (
      <div className="absolute -right-0.5 -top-0.25 z-20 flex size-1.5 items-center justify-center rounded-full bg-[#FC5440]">
        <span className="text-center font-[Inter] text-[6.81px] font-medium leading-none tracking-[0.03em] text-white">
          {count}
        </span>
      </div>
    )}
  </div>
)

export default AttachmentStack
